export enum InputBackgroundType {
  Lowest = 'lowest',
  Low = 'low',
  Normal = 'normal',
  High = 'high',
}
